export default __webpack_public_path__ + "static/media/barbarianbg.c43d683d.jpg";